<script>
import Layout from "@/views/layouts/main.vue";
import CalendarModal from "@/views/pages/project/work_reserves/modals/CalendarModal.vue";
import CarTypesInformation from "@/views/pages/project/work_reserves/components/car_types_information.vue";
import CommonTableComponent from "@/components/table.vue";
import ReservationReflected from "@/views/pages/project/work_reserves/components/reservation_information_reflected.vue";
import WastesOrServicesInfo from "@/views/pages/project/work_reserves/components/wastes_or_services_info.vue";
import SelectWasteOrServiceModal from "@/views/pages/project/work_reserves/modals/SelectWasteOrServiceModal.vue";
import RegularReservationModal from "@/views/pages/project/work_reserves/modals/RegularReservationModal.vue";
import apiEndpoints from "@/services/apiEndpoints";
import {mapGetters} from "vuex";
import CalendarInfo from "@/views/pages/project/work_reserves/components/calendar_info.vue";

const REGULAR_RESERVATION = "regular_reservation";
const RESERVATION_DATES = "reservation_dates";

import tableSearch from "@/mixins/tableSearch";
import ProjectInfo from "@/views/pages/project/sale/project_info.vue";
import router from "@/mixins/router";
import sweetAlert from "@/mixins/sweetAlert";
import user from "@/mixins/user";

const DEFAULT_WORK_RESERVATION_FORM = (params) => {
  return {
    reservation_dates_by_work_reservation: [],
    wastes_or_services_by_work_reservation: [],
    car_estimates_by_work_reservation: [],
    regular_reservation: {},
    regularly_reservation_start_date: '',
    regularly_reservation_end_date: '',
    zz_regularly_reservation_interval_id: '',
    regularly_reservation_day_of_week: [],
    regularly_reservation_date_of_month: '',
    remarks: '',
    work_order_id: null,
    id: null,
    schedule_type: null,
    zz_day_of_time_zone_id: null,
    ...params,
  };
};
export default {
  name: 'WorkReserveRegisterUpdate',
  page: {
    title: "作業予約",
  },
  mixins: [tableSearch, router, sweetAlert, user],
  components: {
    ProjectInfo,
    CommonTableComponent,
    Layout,
    ReservationReflected,
    CalendarModal,
    SelectWasteOrServiceModal,
    RegularReservationModal,
    CarTypesInformation,
    CalendarInfo,
    WastesOrServicesInfo,
  },
  data() {
    return {
      work_reservation: DEFAULT_WORK_RESERVATION_FORM(),
      work_reservations: [],
      key_reservation: 1,
      key_calendar: 1,
      key_calendar_info: 1,
      key_reflected: 1,
      scheduleType: {
        "reservation_dates": RESERVATION_DATES,
        "regular_reservation": REGULAR_RESERVATION
      },
      projectInfos: null,
      errors: {},
      zz_work_order_type_id: null,
    }
  },
  async created() {
    await this.getProject();
  },
  mounted() {
    this.work_reservation.id = this.$_.uniqueId();
  },
  methods: {
    async getProject() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales.replace(
        ":id",
        this.$route.params.case_id
      );
      const sendApiProject = await this.$http.get(url, {});
      const {status, data} = sendApiProject;

      if (status) {
        this.projectInfos = data.result;
      }

      this.isLoading = false;
    },
    onChangeReservations(data) {
      // if (this.isNeedClearReservationDates(data)) {
      //   this.clearReservationDates();
      // }
      this.work_reservation.car_estimates_by_work_reservation = data.carTypes
      const wastesOrServiceByWorkOrder = [...data.wasteOrServices];
      const current = this.work_reservation.wastes_or_services_by_work_reservation;
      
      let wastesOrServicesByWorkReservation = wastesOrServiceByWorkOrder.map((item) => {
        // 変更前から存在するサービス廃棄物は内容を引き継ぎたい
        let currentItem = current.find((cItem) => cItem.wastes_or_services_by_work_order_id == item.wastes_or_services_by_work_order_id);
        if(currentItem){
          return currentItem;
        }else{
          return {
            work_reservation_id: null,
            waste_or_service_by_work_order_id: item.wastes_or_services_by_work_order_id ?? null,
            ...item,
            number_of_manifests: null,
            //waste_estimates_by_work_reservation: this.isWaste(item) ? item.estimates : [],
            waste_estimates_by_work_reservation: item.estimates
          }
        }
      });
      this.$set(this.work_reservation, 'wastes_or_services_by_work_reservation', wastesOrServicesByWorkReservation);
      this.work_reservation.work_order_id = data.workOrderId;
      this.zz_work_order_type_id = data.workOrderType;
    },
    isNeedClearReservationDates(newData) {
      let isChangeWastesOrServices = false;
      let isChangeCarTypes = false;

      const currentWastesOrServicesWorkOrderIds = this.work_reservation.wastes_or_services_by_work_reservation.map(x => x.waste_or_service_by_work_order_id);
      const newWastesOrServicesWorkOrderIds = newData.wasteOrServices.map(x => x.wastes_or_services_by_work_order_id);
      // check if wastes or services has changed, set isChangeWastesOrServices to true.
      if (currentWastesOrServicesWorkOrderIds.length !== newWastesOrServicesWorkOrderIds.length) {
        isChangeWastesOrServices = true;
      }
      if (currentWastesOrServicesWorkOrderIds.some((x, i) => x !== newWastesOrServicesWorkOrderIds[i])) {
        isChangeWastesOrServices = true;
      }

      // check the same with car types
      const currentCarTypes = this.work_reservation.car_estimates_by_work_reservation.map(x => x.id);
      const newCarTypes = newData.carTypes.map(x => x.id);
      if (currentCarTypes.length !== newCarTypes.length) {
        isChangeCarTypes = true;
      }

      return isChangeWastesOrServices || isChangeCarTypes;
    },
    clearReservationDates() {
      this.work_reservation.reservation_dates_by_work_reservation = [];
      this.work_reservation.regular_reservation = {};
      this.work_reservation.regularly_reservation_start_date = '';
      this.work_reservation.regularly_reservation_end_date = '';
      this.work_reservation.zz_regularly_reservation_interval_id = '';
      this.work_reservation.regularly_reservation_day_of_week = [];
      this.work_reservation.regularly_reservation_date_of_month = '';
      this.work_reservation.schedule_type = null;
      this.work_reservation.zz_day_of_time_zone_id = null;
      this.reRenderModal('key_calendar');
    },
    reRenderModal(key) {
      this[key]++;
    },
    onSelectReservationDates(dataSelected) {
      this.work_reservation = {...this.work_reservation, ...dataSelected}
      if (this.work_reservation.schedule_type !== this.scheduleType.regular_reservation) {
        this.resetRegularlyReservationSetting()
      }
      this.$refs.calendarInfo.refreshCalendar(dataSelected.regularly_reservation_start_date, dataSelected.regularly_reservation_end_date);
    },
    resetRegularlyReservationSetting() {
      this.work_reservation.regularly_reservation_start_date = '';
      this.work_reservation.regularly_reservation_end_date = '';
      this.work_reservation.zz_regularly_reservation_interval_id = '';
      this.work_reservation.regularly_reservation_day_of_week = [];
      this.work_reservation.regularly_reservation_date_of_month = '';
      this.work_reservation.zz_day_of_time_zone_id = null;
    },
    async validation() {
      this.errors = {};
      let params = {
        ...this.work_reservation,
        case_id: this.projectId,
      };
      if (!this.projectId) {
        return;
      }

      if (!this.work_reservation.work_order_id || !this.work_reservation.wastes_or_services_by_work_reservation.length) {
        this.errors['wastes_or_services_by_work_reservation'] = ['廃棄物・サービスを入力してください。'];
        return;
      }

      // サービス・廃棄物見積明細のうち少なくとも1つは入力しているかチェック
      for (let index = 0; index < this.work_reservation.wastes_or_services_by_work_reservation.length; index++) {
        const wasteOrService = this.work_reservation.wastes_or_services_by_work_reservation[index];

        const wasteEstimates = wasteOrService.waste_estimates_by_work_reservation;
        let sumQuantity = 0;

        wasteEstimates.forEach(estimate => {
          const quantity = estimate.reservation_quantity ? estimate.reservation_quantity : 0;
          sumQuantity += quantity;
        });

        if (sumQuantity === 0) {
          this.errors['wastes_or_services_by_work_reservation.' + index + '.reservation_quantity'] = ['少なくとも1つ数量を入力してください。'];
          return;
        }
      }

      const url = apiEndpoints.work_reservation_validation(this.projectId, this.work_reservation.work_order_id);

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        if (data.result.contract_warning) {
          this.$swal.fire({
            icon: "warning",
            html: data.result.message,
            width: data.result.width_alert || '70em',
          });
        }

        this.reflectWorkReservation();
        this.resetForm();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    submit() {
      if (!this.work_reservations.length) {
        return;
      }
      if (!this.projectId) {
        return;
      }

      this.confirm(
        '',
        '',
        '予約情報を登録してもよろしいですか。',
        'info',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.register();
        }
      });
    },
    async register() {
      this.errors = {};
      let params = {
        ...this.work_reservations,
      };

      const url = apiEndpoints.work_reservation_create(this.projectId, this.work_reservation.work_order_id);

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        this.successToast("予約情報を登録しました", false, 3000);
        this.redirectToSchedule();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    redirectToSchedule() {
      // 予約登録できるけど営業スケジュールの権限がない人がいるため
      // そういう場合配車課へ飛ばさないといけない
      if(this.canUserShow('schedules')){
        this.$router.push({name: 'schedules'});
      }else if(this.canUserShow('schedules-car')){
        this.$router.push({name: 'schedule.car.list'});
      }else{
        this.$router.push({name: 'projects'});
      }
    },
    reflectWorkReservation() {
      if (!this.work_reservations.some(x => x.id === this.work_reservation.id)) {
        this.work_reservations.unshift({...this.work_reservation});
        return;
      }
      const index = this.work_reservations.findIndex(x => x.id === this.work_reservation.id);
      if (index !== -1) {
        this.work_reservations[index] = {...this.work_reservation};
      }
      this.$nextTick(() => {
        this.reRenderModal('key_reflected');
      })
    },
    scrollIntoError() {
      const el = document.querySelector(".error-message");
      el.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    },
    resetForm() {
      this.work_reservation = DEFAULT_WORK_RESERVATION_FORM({id: this.$_.uniqueId()});
      this.reRenderModal('key_calendar');
      this.reRenderModal('key_calendar_info');
      this.reRenderModal('key_reservation');
    },
    onEditReservation(reservation) {
      this.errors = {};
      this.work_reservation = {
        ...reservation,
        schedule_type: this.isRegularReservation(reservation) ? this.scheduleType.regular_reservation : this.scheduleType.reservation_dates,
        zz_day_of_time_zone_id: this.isRegularReservation(reservation) && reservation.reservation_dates_by_work_reservation.length
          ? reservation.reservation_dates_by_work_reservation[0].zz_day_of_time_zone_id
          : null,
        regularly_reservation_day_of_week: reservation.regularly_reservation_day_of_week ?? [],
        reservation_dates_by_work_reservation: reservation.reservation_dates_by_work_reservation ?? [],
      }
    },
    isRegularReservation(reservation) {
      return reservation.zz_regularly_reservation_interval_id && reservation.regularly_reservation_start_date && reservation.regularly_reservation_end_date;
    },
    backToList() {
      const previousRoute = this.$route.params.previousRoute;
      this.$router.push({
        name: 'projects',
        query: previousRoute && previousRoute.query ? previousRoute.query : {}
      })
    },
    onReservationDeleted(id) {
      const index = this.work_reservations.findIndex(x => x.id === id);
      if (index !== -1) {
        this.work_reservations.splice(index, 1);
      }
    },
    isWaste(wasteOrService) {
      return wasteOrService.type === 'waste'
    },
    setMinNumber (e, number = 1) {
      if (e.target.value < number) e.target.value = number;
    },
    zzMixed(value) {

      if(!value) return '単独';

      const mixed = this.$store.getters['options/options_tables'].zz_mixed_loading ?? [];

      return mixed.filter(item => {
        return item.id == value;
      })[0].mixed_loading;
    },

  },
  computed: {
    projectId() {
      return this.$route.params.case_id;
    },
    ...mapGetters("options", ["options_tables"]),
    headersEstimate() {
      return this.$constant.tableHeaders.work_reservation.table_estimates;
    },
    disabledCalendar() {
      return !this.work_reservation.wastes_or_services_by_work_reservation.length;
    },
    disabledReflectBtn() {
      return this.disabledCalendar
        || (!this.work_reservation.reservation_dates_by_work_reservation.length && !this.isRegularReservation(this.work_reservation));
    },
    zzJwUnits() {
      const jwUnits = this.$store.getters['options/options_tables'].zz_jw_units ?? [];

      return jwUnits.filter(item => {
        const disableJwUnits = this.$constant.disable_zz_jw_units_create_work_order[this.zz_work_order_type_id]
          ?? this.$constant.default_disable_zz_jw_units_create_work_reservation;

        return !disableJwUnits.includes(item.id)
      });
    },
  },
}
</script>

<template>
  <Layout>
    <b-card class="mb-1">
      <ProjectInfo
        :data="projectInfos"
        @redirectBackToList="backToList()"
      />
    </b-card>
    <b-card title="■予約情報">
      <b-row class="mb-2">
        <SelectWasteOrServiceModal
          @dataSelected="onChangeReservations"
          :work_reservation="work_reservation"
          @modalHidden="reRenderModal"
          :key="`cars_${key_reservation}`"
        />
        <div v-if="errors['wastes_or_services_by_work_reservation']" class="error-message">
          {{ errors['wastes_or_services_by_work_reservation'][0] }}
        </div>
        <WastesOrServicesInfo
          :work_reservation="work_reservation"
          :case-id="projectId"
        />
      </b-row>
      <b-row class="mb-2">
        <CarTypesInformation :carTypes="work_reservation.car_estimates_by_work_reservation"/>
        <div v-if="errors['car_estimates_by_work_reservation']" class="error-message">
          {{ errors['car_estimates_by_work_reservation'][0] }}
        </div>
      </b-row>
      <b-row class="mb-2">
        <CalendarModal
          :car_estimates_by_work_reservation="work_reservation.car_estimates_by_work_reservation"
          :disabled="disabledCalendar"
          @dataSelected="onSelectReservationDates"
          :work_reservation="work_reservation"
          :zz_work_order_type_id="zz_work_order_type_id"
          :key="`calendar_${key_calendar}`"
          @modalHidden="reRenderModal"
        />
        <div v-if="errors['reservation_dates_by_work_reservation']" class="error-message">
          {{ errors['reservation_dates_by_work_reservation'][0] }}
        </div>
        <div v-if="errors['schedule_type']" class="error-message">
          {{ errors['schedule_type'][0] }}
        </div>
      </b-row>
      <b-row class="mb-2">
        <CalendarInfo
          ref="calendarInfo"
          :work_reservation="work_reservation"
          :key="`calendar_info_${key_calendar_info}`"
        />
        <div v-if="errors['regularly_reservation_start_date']" class="error-message">
          {{ errors['regularly_reservation_start_date'][0] }}
        </div>
        <div v-if="errors['regularly_reservation_end_date']" class="error-message">
          {{ errors['regularly_reservation_end_date'][0] }}
        </div>
        <div v-if="errors['zz_regularly_reservation_interval_id']" class="error-message">
          {{ errors['zz_regularly_reservation_interval_id'][0] }}
        </div>
        <div v-if="errors['regularly_reservation_day_of_week']" class="error-message">
          {{ errors['regularly_reservation_day_of_week'][0] }}
        </div>
        <div v-if="errors['regularly_reservation_date_of_month']" class="error-message">
          {{ errors['regularly_reservation_date_of_month'][0] }}
        </div>
      </b-row>
      <b-row
        v-for="(waste_or_service, index) in work_reservation.wastes_or_services_by_work_reservation"
        :key="`wastes_or_services_by_work_reservation_${index}`"
        class="estimates-area"
      >
        <b-row class="mt-2">
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
            <tr>
              <th>廃棄物・サービス名</th>
              <template v-if="isWaste(waste_or_service)">
                <th>廃棄物種類</th>
                <th>運搬先</th>
                <th>処分方法</th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{waste_or_service.name}}</td>
              <template v-if="isWaste(waste_or_service)">
                <td>{{waste_or_service.waste_category_of_treatment_name_abbreviated}}</td>
                <td>{{waste_or_service.vendor_sites_name_abbreviated}}</td>
                <td>{{waste_or_service.treatment_method}}</td>
              </template>
            </tr>
            </tbody>
          </CommonTableComponent>
        </b-row>
        <b-row class="mt-2" v-if="isWaste(waste_or_service)">
          <b-col cols="3" style="width: 20%">
            <div class="input-group mb-1">
              <span class="input-group-text">マニフェスト枚数</span>
              <b-form-input
                @keyup="setMinNumber($event)"
                v-model="waste_or_service.number_of_manifests"
                v-empty-if-negative-int
                class="form-control"
                type="number"
                :min="1"
              ></b-form-input>
              <span class="input-group-text">枚</span>
            </div>
            <div v-if="errors[`wastes_or_services_by_work_reservation.${index}.number_of_manifests`]" class="error-message">
              {{ errors[`wastes_or_services_by_work_reservation.${index}.number_of_manifests`][0] }}
            </div>
          </b-col>
          <b-col cols="3"  style="width: 20%">
            <div class="input-group mb-1">
              <span class="input-group-text">マニフェスト準備担当</span>
              <input
                type="text"
                id="manifest_preparation_role"
                class="form-control"
                :value="waste_or_service.manifest_preparation_role"
                readonly
                style="background-color: white;"
              >
            </div>
          </b-col>
          <b-col cols="2" style="width: 13%">
            <div class="input-group mb-1">
              <span class="input-group-text">単独・合積</span>
              <input
                type="text"
                id="mixed_loading_kbn_string"
                class="form-control"
                :value="zzMixed(waste_or_service.mixed_loading_kbn)"
                readonly
                style="background-color: white;"
              >
            </div>
          </b-col>
          <b-col cols="2" style="width: 13%">
            <div class="input-group mb-1">
              <span class="input-group-text">予定重量</span>
              <b-form-input
                v-model="waste_or_service.measurement_quantity"
                id="measurement_quantity"
                class="me-2"
                type="number"
                :min="1"
              ></b-form-input>
            </div>
          </b-col>
          <b-col>
            <b-form-radio-group
              text-field="jw_unit"
              value-field="id"
              class="d-flex align-items-center gap-2 w-100 h-100 custom-checkbox custom-control-input"
              v-model="waste_or_service.zz_quantity_confirmation_unit_id"
              :options="zzJwUnits"
            ></b-form-radio-group>
          </b-col>
        </b-row>
        <b-row
          class="mt-2"
          v-if="waste_or_service.waste_estimates_by_work_reservation && waste_or_service.waste_estimates_by_work_reservation.length"
        >
          <CommonTableComponent :height-class="`table-wrapper-300`">
              <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headersEstimate"
                  :key="index"
                  :class="[...getHeaderClass(item), 'text-center']"
                >
                  <span v-html="item.text"> </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(estimate, indexE) in waste_or_service.waste_estimates_by_work_reservation" :key="`estimates_by_wastes_or_service_${indexE}`">
                <td>{{ estimate.estimate_cd }}</td>
                <td>{{ estimate.invoice_product_name }}</td>
                <td>
                  <b-form-input
                    type="number"
                    v-model="estimate.reservation_quantity"
                    :min="1"
                  ></b-form-input>
                  <div v-if="errors[`wastes_or_services_by_work_reservation.${index}.waste_estimates_by_work_reservation.${indexE}.reservation_quantity`]" class="error-message">
                    {{ errors[`wastes_or_services_by_work_reservation.${index}.waste_estimates_by_work_reservation.${indexE}.reservation_quantity`][0] }}
                  </div>
                  <div v-if="errors[`wastes_or_services_by_work_reservation.${index}.reservation_quantity`]" class="error-message">
                    {{ errors[`wastes_or_services_by_work_reservation.${index}.reservation_quantity`][0] }}
                  </div>
                </td>
                <td>
                  {{estimate.zz_unit ? estimate.zz_unit.unit : ''}}
                </td>
                <td>
                  <b-form-input
                    type="text"
                    v-model="estimate.reservation_number_of_rental_containers"
                    maxLength="50"
                    :disabled="!isWaste(waste_or_service)"
                  ></b-form-input>
                  <div v-if="errors[`wastes_or_services_by_work_reservation.${index}.waste_estimates_by_work_reservation.${indexE}`]" class="error-message">
                    {{ errors[`wastes_or_services_by_work_reservation.${index}.waste_estimates_by_work_reservation.${indexE}`][0] }}
                  </div>
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
        </b-row>
      </b-row>
      <b-row class="mt-2 mb-2">
        <div class="input-group">
          <span class="input-group-text">要望入力欄</span>
          <b-form-textarea
            rows="4"
            max-rows="6"
            v-model="work_reservation.remarks"
          ></b-form-textarea>
        </div>
      </b-row>
      <b-row class="mb-2">
        <div class="d-xl-flex mr-2">
          <button
            class="btn btn-primary waves-effect waves-light"
            @click="validation"
            :disabled="disabledReflectBtn"
          >
            <i class='fas fa-plus'></i> 予約情報一時保存
          </button>
        </div>
      </b-row>
      <b-row class="mb-2 justify-content-center m-0">
        <ReservationReflected
          :case_id="Number(projectId)"
          @edit="onEditReservation"
          @reservationDeleted="onReservationDeleted"
          :work_reservations="work_reservations"
          class="p-0"
          :key="key_reflected"
        />
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <div class="d-flex justify-content-center">
          <b-button
            size="lg"
            variant="primary"
            @click="submit"
            v-if="canUserEdit()"
          >
            <i class="fas fa-pencil-alt"></i> 予約登録
          </b-button>
        </div>
      </b-row>
    </b-card>
  </Layout>
</template>

<style scoped lang="scss">
.estimates-area {
  justify-content: center;
  width: 100%;
  border: 1px solid #343a40;
  padding: 10px;
  margin-left: 0;
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px #aaa;
}
</style>
